import React from 'react';
import { AltOffering } from '@benzinga/alts-manager';
import { Grid } from '@benzinga/core-ui';
import { ListingPreview } from './ListingPreview';
import { OfferingCardVariant } from '../types';

export interface OfferingsGridProps {
  handleLeadCapture?: () => void;
  offerings: AltOffering[];
  onTagClick?: (label: string, value: string) => void;
  variant?: OfferingCardVariant;
}

export const OfferingsGrid: React.FC<OfferingsGridProps> = ({ handleLeadCapture, offerings, onTagClick, variant }) => {
  return (
    <Grid className="offerings-list-container" maxColumns={3}>
      {Array.isArray(offerings) &&
        offerings?.map(offering => (
          <ListingPreview
            handleLeadCapture={handleLeadCapture}
            key={offering.id}
            listing={offering}
            onTagClick={onTagClick}
            showGetStartedLink={true}
            variant={variant}
          />
        ))}
    </Grid>
  );
};
